import React from "react";

import Page from "EmployeeApplication/Page";
import ApplicationLayout from "EmployerApplication/Components/ApplicationLayout";

import { CardHeader, CardSection } from "Common/Card";
import Icon from "Common/Icon";

const DonePage = () => (
  <Page title="You are done">
    <CardHeader>
      You are done! <Icon icon="smile" />
    </CardHeader>
    <CardSection>
      Our team will be in touch once your renewal is approved. If you have questions in the meantime please check out our{" "}
      <a href="https://support.simplyinsured.com/s/article/The-SimplyInsured-Guide-to-Your-Annual-Health-Insurance-Renewal">Guide to Renewals</a>.
    </CardSection>
  </Page>
);

export default DonePage;
